export var Gender;
(function (Gender) {
    Gender["Male"] = "male";
    Gender["Female"] = "female";
})(Gender || (Gender = {}));
export var MonsterTypes;
(function (MonsterTypes) {
    MonsterTypes["Water"] = "water";
    MonsterTypes["Fire"] = "fire";
    MonsterTypes["Earth"] = "earth";
    MonsterTypes["Electric"] = "electric";
    MonsterTypes["Flying"] = "flying";
    MonsterTypes["Physical"] = "physical";
})(MonsterTypes || (MonsterTypes = {}));
